import React from "react";
import "./Business.css";

export default function Business() {
  return (
    <div className="page">

      {/* HERO */}
      <section className="business-hero">
        <div className="business-hero-inner">
          <div className="business-hero-card">

            <div className="business-pill">
              For Event Organisers
            </div>

            <h1 className="business-title">
              Environmental intelligence for sporting events.
            </h1>

            <p className="business-subtitle">
              ASDRY helps organisers understand how forecast conditions
              affect competitors, volunteers, spectators, and infrastructure —
              before operational decisions need to be made.
            </p>

            <div className="business-actions">
              <a href="/contact" className="business-primary">
                Request Information →
              </a>
            </div>

          </div>
        </div>
      </section>

      <div className="page-container">

        {/* PROBLEM */}
        <section className="content-card" style={{ marginTop: "64px" }}>
          <div className="card-body">
            <h2 className="content-subtitle">
              Weather data doesn’t equal operational clarity.
            </h2>

            <p>
              Forecasts provide temperature, wind speed, and precipitation.
              But organisers need to understand what those conditions mean
              for safety, staffing, course setup, medical planning,
              and participant experience.
            </p>

            <p>
              ASDRY translates raw forecast inputs into structured
              environmental impact levels aligned to real event operations.
            </p>
          </div>
        </section>

        {/* HOW IT WORKS */}
        <section className="content-card" style={{ marginTop: "32px" }}>
          <div className="card-body">
            <h2 className="content-subtitle">
              How ASDRY supports event decisions
            </h2>

            <ul>
              <li>
                <strong>Multi-profile modelling</strong> —
                Separate exposure assessment for competitors,
                volunteers, spectators, and infrastructure.
              </li>
              <li>
                <strong>AERS impact levels</strong> —
                Structured environmental stress scoring
                aligned to preparation levels.
              </li>
              <li>
                <strong>Operational summaries</strong> —
                Clear preparation guidance for planning teams.
              </li>
              <li>
                <strong>Escalation awareness</strong> —
                Sensitivity indicators when conditions
                approach critical thresholds.
              </li>
            </ul>
          </div>
        </section>

        {/* USE CASES */}
        <section className="content-card" style={{ marginTop: "32px" }}>
          <div className="card-body">
            <h2 className="content-subtitle">
              Built first for multi-event sports organisers
            </h2>

            <p>
              From road races and endurance events to recurring
              outdoor competitions, ASDRY is designed for organisers
              managing multiple events across a season —
              where consistency, safety, and reputation matter.
            </p>

            <p>
              The same modelling framework can extend into
              public gatherings, site operations, and
              other outdoor environments where conditions
              directly influence operational exposure.
            </p>
          </div>
        </section>

        {/* EXAMPLE EVENT BRIEFING */}
        <section className="content-card" style={{ marginTop: "64px" }}>
          <div className="card-body">
            <h2 className="content-subtitle">
              Example Event Briefing
            </h2>

            <h3 style={{ marginTop: "24px" }}>Pre‑Event Review</h3>
            <p>
              Forecast conditions indicate moderate environmental load driven primarily
              by sustained rainfall exposure. Surface conditions, visibility, and
              extended exposure for operational staff require pre‑event review.
            </p>

            <h3 style={{ marginTop: "24px" }}>Operational Posture</h3>
            <p>
              Preparation Level: <strong>MODERATE</strong>
            </p>
            <p>
              Recommended posture: Increase monitoring, brief operational leads,
              and prepare adaptive controls should rainfall intensity increase.
            </p>

            <h3 style={{ marginTop: "24px" }}>Profile Risk Map</h3>
            <ul>
              <li><strong>Competitors:</strong> Surface grip and pacing impact.</li>
              <li><strong>Spectators:</strong> Comfort and visibility exposure.</li>
              <li><strong>Volunteers:</strong> Extended exposure fatigue risk.</li>
              <li><strong>Infrastructure:</strong> Drainage and temporary structure monitoring.</li>
            </ul>

            <h3 style={{ marginTop: "24px" }}>Recommended Controls</h3>
            <ul>
              <li>Pre‑event briefing for team leads.</li>
              <li>Surface inspection before start time.</li>
              <li>Volunteer rotation planning for exposed areas.</li>
              <li>Equipment weatherproofing verification.</li>
            </ul>

            <p style={{ marginTop: "24px", fontStyle: "italic" }}>
              Full production briefings include escalation thresholds, sensitivity
              indicators, and scenario modelling beyond this illustrative example.
            </p>
          </div>
        </section>

        {/* FINAL CTA */}
        <section style={{ marginTop: "64px", textAlign: "center" }}>
          <a
            href="/contact"
            className="business-primary"
          >
            Discuss Implementation →
          </a>
        </section>

      </div>
    </div>
  );
}

export {};